/** 1週間の日数 */
export const DAYS_PER_WEEK = 7;

/** カレンダーに表示する週数 */
export const CALENDAR_WEEKS = 6;

/** カレンダーに表示する日数（6週間分） */
export const CALENDAR_DAYS = DAYS_PER_WEEK * CALENDAR_WEEKS;
